module.exports = __webpack_public_path__ + "img/Mills_SuperOK-69.7e337c6a.jpg";